module.exports = __webpack_public_path__ + "static/media/footerImage.08fbaead.webp";